// Frontend Fix
import { Component, useEffect, useRef, useState } from "react";
import io from "socket.io-client";
import DefaultFrame from "../../components/DefaultFrame";
import { Box, Grid, Paper, Typography } from "@mui/material";
import { APIData } from "../../constants/APIAdresses";

const processNames = {
    uapi: "UserAPI",
    sapi: "ShopAPI",
    rapi: "RealtimeAPI",
    mapi: "MediaAPI",
};

function LogDashboardInnerView() {
    const [logs, setLogs] = useState({ uapi: [], sapi: [], rapi: [], mapi: [] });
    // const [logs, setLogs] = useState({ uapi: 
    //     [
    //         "Lat & Lon Specified calculating edges for 25 kilometers.",
    //         "DBHelper getShops zip= 28201  sectorId= 1  isDelivery= false  nameSearch='undefined'  offset= 0  bigDisplay= false positionData= { lat: '53.0625893', lon: '8.8093295' }",
    //         "Processing __checkAddPostalCodeAndGetPosRange with lat= 53.0625893  lon= 8.8093295  postalCode= 28201",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Lat & Lon Specified calculating edges for 25 kilometers.",
    //         "DBHelper getShops zip= 28201  sectorId= 1  isDelivery= false  nameSearch='undefined'  offset= 0  bigDisplay= false positionData= { lat: '53.0625893', lon: '8.8093295' }",
    //         "Processing __checkAddPostalCodeAndGetPosRange with lat= 53.0625893  lon= 8.8093295  postalCode= 28201",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).", "Lat & Lon Specified calculating edges for 25 kilometers.",
    //         "DBHelper getShops zip= 28201  sectorId= 1  isDelivery= false  nameSearch='undefined'  offset= 0  bigDisplay= false positionData= { lat: '53.0625893', lon: '8.8093295' }",
    //         "Processing __checkAddPostalCodeAndGetPosRange with lat= 53.0625893  lon= 8.8093295  postalCode= 28201",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).", "Lat & Lon Specified calculating edges for 25 kilometers.",
    //         "DBHelper getShops zip= 28201  sectorId= 1  isDelivery= false  nameSearch='undefined'  offset= 0  bigDisplay= false positionData= { lat: '53.0625893', lon: '8.8093295' }",
    //         "Processing __checkAddPostalCodeAndGetPosRange with lat= 53.0625893  lon= 8.8093295  postalCode= 28201",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).", "Lat & Lon Specified calculating edges for 25 kilometers.",
    //         "DBHelper getShops zip= 28201  sectorId= 1  isDelivery= false  nameSearch='undefined'  offset= 0  bigDisplay= false positionData= { lat: '53.0625893', lon: '8.8093295' }",
    //         "Processing __checkAddPostalCodeAndGetPosRange with lat= 53.0625893  lon= 8.8093295  postalCode= 28201",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //         "Released MySQL Connection (Still Active: 0).",
    //       ]
    //     , sapi: [], rapi: [], mapi: [] });
    const logRefs = {
        uapi: useRef(null),
        sapi: useRef(null),
        rapi: useRef(null),
        mapi: useRef(null),
    };
    const [autoScroll, setAutoScroll] = useState({
        uapi: true,
        sapi: true,
        rapi: true,
        mapi: true,
    });

    const handleScroll = (key) => {
        const el = logRefs[key].current;
        if (!el) return;

        const atBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 10;
        setAutoScroll((prev) => ({ ...prev, [key]: atBottom }));
    };

    useEffect(() => {
        // Scroll to bottom only if autoScroll is enabled
        Object.keys(processNames).forEach((key) => {
            const el = logRefs[key].current;
            if (el && autoScroll[key]) {
                el.scrollTop = el.scrollHeight;
            }
        });
    }, [logs]);

    useEffect(() => {
        // Fetch all buffered logs at once
        fetch(APIData.LOGS + "/logbuffer", {
            credentials: "include",
        })
            .then(res => res.json())
            .then(data => {
                // Make sure all expected keys are present
                const initialLogs = {};
                Object.keys(processNames).forEach(proc => {
                    initialLogs[proc] = Array.isArray(data[proc]) ? data[proc].slice(-100) : [];
                });
                setLogs(initialLogs);
            })
            .catch(err => console.error("Error fetching log buffer:", err));
        const socket = io("wss://logs.viveel.de", {
            withCredentials: true,
            transports: ["websocket"],
            reconnection: true,
            reconnectionAttempts: 5,
            reconnectionDelay: 1000,
            reconnectionDelayMax: 5000,
        });

        socket.on("log", (data) => {
            const { app, message } = data;
            if (processNames[app]) {
                setLogs((prev) => ({
                    ...prev,
                    [app]: [...prev[app].slice(-99), message],
                }));
            }
        });

        Object.keys(processNames).forEach((proc) => {
            console.log("Joining process: ", proc);
            socket.emit("join", proc, (response) => {
                console.log("Response: ", response);
                if (response.success) {
                    console.log(`✅ Successfully joined room: ${response.room}`);
                } else {
                    console.warn(`❌ Failed to join room: ${proc} → ${response.message}`);
                }
            });
        });

        return () => socket.disconnect();
    }, []);

    return (
        <Box sx={{ p: 2, bgcolor: "#111", minHeight: "100vh", color: "white" }}>
            <Typography variant="h4" align="center" gutterBottom>
                Live Application Logs
            </Typography>
            <Grid container spacing={2}>
                {Object.entries(processNames).map(([key, title]) => (
                    <Grid item xs={12} sm={6} key={key}>
                        <Paper elevation={3} sx={{ display: "flex", flexDirection: "column", bgcolor: "#1e1e1e", p: 2, border: "1px solid #333", height: "calc(100vh / 2.5)", overflow: "hidden" }}>
                            <Typography variant="h6" sx={{ color: "#4fc3f7", mb: 1 }}>
                                {title}
                            </Typography>

                            <Box
                                ref={logRefs[key]}
                                onScroll={() => handleScroll(key)}
                                sx={{
                                    flex: 1,
                                    overflowY: "hidden", // disables vertical scroll bar
                                    fontFamily: "monospace",
                                    fontSize: 13,
                                    whiteSpace: "pre-wrap",
                                    color: "#81c784",
                                }}
                            >
                                {logs[key].map((line, idx) => (
                                    <div key={idx}>{line}</div>
                                ))}
                            </Box>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default function LogDashboardPage() {
    return (
        <DefaultFrame title="Logs" padding={0}>
            <LogDashboardInnerView />
        </DefaultFrame>
    );
}